module.exports = __webpack_public_path__ + "media/img/help_center/Student_Scholarship_Search_03-7d098efd0f3297af5f14c2a6bb0190f6.jpg";